export default "__VITE_PUBLIC_ASSET__5eb8c8c0__"